function normalizeToken(candidate: string | null | undefined): string {
  return candidate ? decodeURIComponent(candidate).trim() : '';
}

function extractTokenFromPath(pathname: string): string {
  const segments = pathname
    .split('/')
    .map((segment) => segment.trim())
    .filter(Boolean);

  if (segments.length >= 2 && segments[0].toLowerCase() === 'r') {
    return normalizeToken(segments[1]);
  }

  return '';
}

export function extractQrToken(rawValue: string): string {
  const trimmed = rawValue.trim();
  if (!trimmed) {
    return '';
  }

  if (/^https?:\/\//i.test(trimmed)) {
    try {
      const url = new URL(trimmed);
      const queryToken = normalizeToken(url.searchParams.get('qr'));
      if (queryToken) {
        return queryToken;
      }

      const pathToken = extractTokenFromPath(url.pathname);
      if (pathToken) {
        return pathToken;
      }

      return trimmed;
    } catch {
      return trimmed;
    }
  }

  const pathToken = extractTokenFromPath(trimmed);
  if (pathToken) {
    return pathToken;
  }

  return trimmed;
}
